import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const BlockAlignmentRightIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "BlockAlignmentRight",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M3.17 18.12v-4.25c0-2.05 1.66-3.71 3.71-3.71h13.58c2.05 0 3.71 1.66 3.71 3.71v4.25c0 2.05-1.66 3.71-3.71 3.71H6.88c-2.05 0-3.71-1.66-3.71-3.71M27.89 30h-.44c-.52 0-.94-.42-.94-.95V2.94c0-.52.42-.94.94-.94h.44c.52 0 .94.42.94.94v26.11c0 .52-.42.95-.94.95"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.57 29.29c-.63 0-1.14-.51-1.14-1.14V3a1.14 1.14 0 1 1 2.28 0v25.14c0 .63-.51 1.14-1.14 1.14ZM22 21.29H8.29c-1.89 0-3.43-1.54-3.43-3.43v-4.57c0-1.89 1.54-3.43 3.43-3.43H22a1.14 1.14 0 1 1 0 2.28H8.29c-.63 0-1.14.51-1.14 1.14v4.57c0 .63.51 1.14 1.14 1.14H22a1.14 1.14 0 1 1 0 2.28Z"
      })
    })
  }));
};
BlockAlignmentRightIcon.displayName = 'BlockAlignmentRightIcon';